import { useContext } from "react";
import { AutocompleteInput, AutocompleteInputProps } from "react-admin";

import { InputChoicesType, InputChoiceType } from "../App.types";
import { InputChoicesContext } from "../BackendDataContext";

type BackendChoiceSelectInputPropsType = AutocompleteInputProps & {
  choicesType: keyof InputChoicesType;
  filterChoices?: ((choices: InputChoiceType[]) => InputChoiceType[]) | null;
};

export default function BackendChoiceSelectInput(props: BackendChoiceSelectInputPropsType) {
  const { choicesType = "event_statuses", filterChoices = null, ...rest } = props;

  const inputChoices = useContext(InputChoicesContext);
  let choices = inputChoices[choicesType] || [];

  if (filterChoices) {
    choices = filterChoices(choices);
  }

  if (!choices || choices.length === 0) return null;

  return <AutocompleteInput {...rest} choices={choices} />;
}
